require('./Cropper/cropper.css')
require('!script-loader!./Scriptaculous/scriptaculous.js')
require('!script-loader!./Scriptaculous/effects-minified.js')
require('!script-loader!./Scriptaculous/dragdrop.js')
require('./Foundation/Image/Editor.js')
